import { Modal, Space } from 'antd'
import styled from 'styled-components'

export const StyledModal = styled(Modal)<{ $height: number }>`
  .container-body {
    padding: 16px 24px 16px 24px;
    max-height: 80vh;
    overflow: auto;
  }
  .ant-modal-close-x {
    font-weight: 600;
    font-size: 1.8rem;
    color: var(--color-gray-111);
    &:hover {
      opacity: 0.85;
      color: var(--color-gray-109);
    }
  }
  &.document-modal {
    height: ${({ $height }) => $height}px;
    width: ${({ $height }) => ($height * 210) / 297}px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    .container-body {
      max-height: 100vh;
    }
    .ant-modal-content,
    .ant-modal-footer {
      border-radius: 0;
      width: 100%;
      position: relative;
    }
    .ant-modal-footer {
      position: absolute;
      background: transparent;
      bottom: 0;
      button {
        align-items: center;
        justify-content: center;
        display: flex;
        height: 32px;
      }
      .ant-space {
        background: transparent;
        // justify-content: flex-start;
        padding: 4px;
      }
    }
    .container-body {
      height: ${({ $height }) => $height}px;
      width: ${({ $height }) => ($height * 210) / 297}px !important;
      .page-document {
        height: ${({ $height }) => $height}px;
        width: ${({ $height }) => ($height * 210) / 297}px !important;
      }
      // font-size: 1rem;
      padding: 0;
      overflow-x: hidden;
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
      }
    }
    .ant-modal-footer {
    }
  }
`

export const StyledFooterRow = styled(Space)`
  justify-content: flex-end;
  display: flex;
  background: var(--color-gray-101);
  padding: 12px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`
